module.exports = __webpack_public_path__ + "static/assets/f02cfe107b0c050291c3a9e9466bcff6.gif";